<template>
  <BaseLayout @click-back="back" isFunction="true" hasBottomButton="true" hasHeaderBar="true">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">供應商</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.supplierStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.supplierEndForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">電話</div>
      </div>
      <input v-model="searchData.telephoneNoForSearch" type="text" class="form-control" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">名稱</div>
      </div>
      <input v-model="searchData.supplierNameForSearch" type="text" class="form-control" />
    </div>
    <div class="list-group" style="text-align: left;">
      <template v-for="form in gridData">
        <div :key="form.SupplierId" class="list-group-item list-group-item-action">
          <div
            class="d-flex w-100 justify-content-between"
            style=" background:#EEE; padding: 5px 5px 0px 5px"
          >
            <b class="mb-1">{{form.SupplierId}} {{form.SupplierAbbreviation}}</b>
          </div>
          <div class="d-flex flex-row">
            <p class="mb-1 w-100" style="backgroun-color:#EEE;  word-break: break-all;">
              <span class="badge badge-light">幣別:{{form.TradeCurrency}}</span>
              <span class="badge badge-light">交易方式:{{form.PaymentDays}}</span>
            </p>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">計稅方式:{{form.TaxCode}}</span>
            <span class="badge badge-light">營業稅率:{{form.TaxRate}}</span>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">電話:{{form.TelephoneNo1}}</span>
            <span class="badge badge-light">業務聯絡:{{form.SupplierSales}}</span>
          </div>
        </div>
      </template>
    </div>

    <button @click="query" type="button" class="btn-xl btn btn-primary btn-circle">
      <i class="fas fa-search"></i>
    </button>
  </BaseLayout>
</template>
<script>
export default {
  name: "SupplierChain",
  data: function() {
    return {
      searchData: {
        companyId: this.$store.state.companyId,
        supplierStartForSearch: "",
        supplierEndForSearch: "",
        telephoneNoForSearch: "",
        supplierNameForSearch: ""
      },
      gridData: []
    };
  },
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    query: function() {
      var _this = this;
      this.startLoad();
      _this.$http
        .post("/WebApp/SupplierChain/Query", {
          ...this.searchData
        })
        .then(res => {
          _this.gridData = res.data;
          _this.endLoad();
        })
        .catch(err => {
          _this.endLoad();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-circle.btn-xl {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}
.input-group > .input-group-prepend:first-child > .input-group-text {
  width: 5.8rem;
}
</style>